const uvVisJcamp = `
##TITLE=ML-518_30min
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1
$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=ML-518_30min
##JCAMP-DX=5.00
##DATA TYPE=UV/VIS SPECTRUM
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=MINUTES
##YUNITS=mAU
##XFACTOR=1.0
##YFACTOR=0.00024426
##FIRSTX=10.000167
##LASTX=0.0
##MAXX=10.000167
##MAXY=244.26
##MINX=0.0
##MINY=0.0
##NPOINTS=2374
##XYDATA= (X++(Y..Y))
2374F959F967F972F976F976F972F976F972F976F976F959F947F947F951F955F951F947
2357F943F939F935F931F939F943F935F927F922F918F922F918F914F910F906F906F910
2340F914F910F902F902F914F918F918F914F914F906F902F898F898F910F910F910F914
2323F922F918F914F914F910F914F918F918F918F914F914F918F922F922F918F927F935
2306F943F947F959F967F967F963F963F967F976F980F984F984F996G017G017G017G017
2289G025G029G045G045G041G041G041G045G049G049G053G062G066G070G078G086G103
2272G123G131G131G139G144G160G168G172G184G193G197G201G209G213G213G217
2256G221G246G254G258G258G250G246G250G246G242G238G238G242G242G242G238
2240G234G230G230G225G225G221G213G209G205G197G193G193G193G184G180G176
2224G172G168G168G160G156G152G144G135G127G123G123G119G115G111G107G103
2208G094G094G090G086G078G070G074G078G082G086G086G086G090G094G098G103
2192G107G115G127G135G139G144G139G135G131G135G144G152G156G164G172G176
2176G189G193G197G205G205G205G209G217G225G230G238G246G254G258G266G279
2160G287G299G315G336G352G373G393G418G451G492G532G565G598G635G676G721
2144G794G885G962H032H093H159H233H310H396H486H531H560H621H699H777H859
2128H941I031I440I915A0054A0136A0218A0296A0386A0476A0546A0611A0673A0726
2114A0767A0791A0808A0804A0799A0787A0759A0697A0615A0550A0468A0390A0304
2101A0230A0194I989I637I448I362I285I207I121I031H949H871H802H736H662H609
2085H552H499H454H421H388H351H314H278H241H208H175H138H106H077H044H011
2069G979G946G913G897G880G848G815G790G766G749G729G692G635G590G565G541
2053G528G520G516G504G492G479G471G459G451G442G434G422G418G414G414G418
2037G426G434G442G446G451G455G459G463G471G475G475G479G487G496G504G508
2021G516G524G532G545G557G573G594G602G610G618G631G651G668G692G717G733
2005G745G762G778G790G811G840G860G872G880G893G930G942G938G938G934G930
1989G925G917G909G897G885G868G852G835G823G811G794G774G749G721G692G663
1973G639G606G569G537G504G479G471G463G451G442G434G426G422G410G406G401
1957G393G389G385G381G377G373G365G356G352G352G348G348G348G352G361G369
1941G369G369G377G385G393G397G401G410G418G418G414G414G410G406G401G397
1925G393G393G389G389G397G401G406G414G418G422G426G426G422G422G430G430
1909G426G430G434G442G446G455G459G467G475G479G487G496G504G508G516G516
1893G516G520G520G520G516G512G508G504G504G504G504G508G512G520G524G532
1877G537G545G557G565G577G590G606G618G627G635G647G655G668G680G692G708
1861G721G737G754G770G790G811G835G860G880G901G921G954G983H016H032H044
1845H061H077H097H118H138H159H179H212H245H273H298H327H355H384H413H445
1829H478H511H540H576H617H675H761H851H924I002I084I162I248I354I457I682
1813I923A0087A0255A0349A0435A0640A0865A1078A1332A1610A1893A2249A2580
1800A2846A3289A3837A4619A5270A5622A6273A6928A7333A7898A8627A9159A9872
1787B0940B1673B2439B3581B4465B5088B5996B7175B8035B8977C0610C1879C2919
1774C4508C5896C7026C8389C9924D1468D3367D4952D6069D7797D9222D9959E1076
1761E2456E3148E3336E4032E5166E5858E6059E6431E6980E7307E7303E7242E7197
1748E7058E6599E5870E5432E4961E4012E2849E2108E1408D9308D7461D6442D4292
1735D2319D1099C7906C2940C0086B9051B6660B4604B3405B1313A9909A8942A7428
1722A6400A5962A5282A4357A3764A3358A2638A2052A1823A1553A1180A0906A0775
1709A0615A0382A0259A0243A0210A0132A0058A0058A0083A0128A0210A0284A0382
1696A0521A0648A0804A0992A1156A1328A1516A1704A2060A2474A2773A3023A3268
1683A3551A3804A4152A4603A5041A5454A5831A6195A6556A7170A7788A8136A8484
1670A8832A9188A9602A9962B0285B0469B0494B0588B0817B1018B1125B1235B1333
1657B1370B1362B1354B1346B1280B1125B0981B0863B0658B0396B0183A9900A9528
1644A9204A8889A8484A8029A7575A6985A6335A5700A5098A4574A3960A3461A3076
1631A2601A2232A1929A1577A1299A1086A0836A0558A0325A0112I895I727I567I399
1617I264I113I027I019H974H896H818H744H671H601H552H507H478H445H429H421
1601H409H413H417H421H429H441H450H462H478H495H515H544H576H609H642H675
1585H707H728H740H752H769H789H806H814H818H822H818H814H810H798H777H752
1569H724H691H658H626H597H568H540H507H474H450H441H433H425H421H413H409
1553H404H400H404H417H429H445H466H486H511H540H572H605H646H695H773H871
1537H957H998I002I051I137I231I334I436I539I645I751I858I932I972A0005A0038
1521A0067A0087A0095A0103A0108A0099A0091A0083A0071A0058A0046A0030A0013
1508I997I985I977I964I960I956I956I956I956I960I977I997A0042A0128A0226A0292
1492A0366A0451A0537A0652A0775A0926A1115A1287A1463A1692A2060A2376A2580
1479A2875A3186A3497A3944A4341A4738A5299A5720A6154A6789A7333A7747A8324
1466A9049A9561B0293B1317B2017B2504B3405B4703B5403B5505B5964B7028B8371
1453B9255C1589C3947C5384C7971C9670D0706D2630D4976D6475D7711D9991E2779
1440E4495E5342E7725F1450F3759F4799F7743G2418G5194G6455G9722H4676H7648
1427H8929I2589I8358A01911A04053A08151A13461A17080A19962A25026A31360A38057
1415A45124A49537A51563A55657A61504A64889A67530A73135A76909A77519A79509
1404A83099A85155A85576A85740A86371A87472A88061A88090A87726A86608A84966
1393A84045A83824A81114A76041A73245A72688A68488A60709A56206A55228A53185
1382A47334A38729A33558A28117A18848A11663A07532A01228I1951H6387H4618G9362
1370G0490F5397F4267F0566E3074D8341D7449D5914D2606C8454C5998C5359C3652
1357C0217B8052B7646B7057B5161B3622B3389B3000B2537B2259B2291B2431B2619
1344B2742B2864B3352B4117B4588B4871B5636B6795B7540B8219B9394C0758C1499
1331C1830C3099C5085C6354C6968C8659D1341D2933D3777D5889D9001E0876E1686
1318E4233E8400F0804F4312G0044G3016G6754H3828H7955H8913I3400A01215A05702
1305A06738A11139A21223A28121A29386A31724A38811A49549A55776A57369A65667
1294A80713A89011A90362A98440B16773B28580B30193B32403B43097B63014B74813
1283B77069B81789B90014C12097C30713C33452C49488C78559C94600C97175D31372
1272D66142D69606D79071E17108E48808E52079E93150F36285F48976F89421G28420
1261G75059H17448H56443H94710H97850I00446I30013I59584I61843I79267I96978
1250I98137I99062A000000I99762I81364I62961I61459I51674I14971H85613H82895
1239H71436H19417G74453G69868G64562G00908F36166F13829E49901D98313D88405
1228D53410C91902C59031C54945C28756B74572B42962B39560B31229B06931A72218
1217A53471A50908A47060A42733A29259A04724I1255H9515H7116G7233F1061E2374
1205E1310D8321D2016C4713C0729C0152B7822B3086B0273A9921A9049A7211A6052
1192A5819A5688A5397A5008A4791A4844A4992A5106A5344A5704A6281A6871A7293
1179A7968A8570A8955A9344A9716B0015B0261B0539B0785B0965B1182B1395B1497
1166B1583B1685B1759B1763B1739B1710B1583B1395B1284B1084B0756B0527B0248
1153A9823A9426A9008A8537A8013A7489A7133A6879A6552A6290A6175A6081A5937
1140A5864A5942A6068A6150A6294A6584A6949A7190A7452A7964A8607A9032A9683
1127B0899B1735B2279B3278B4535B5366B6099B7417B9026C0054C1360C3886C5683
1114C6391C8315D1378D3195D4550D7117E0167E2046E7467F2670F3023F5851G1911
1101G5755G8363H5548I1066I5525A03946A09010A11078A16085A23675A28518A30000
1089A35982A46511A52693A59182A70465A77593A89126B01940B07062B14554B24682
1078B30545B41570B52558B53786B56779B64726B70515B71116B71567B75374B79046
1067B79255B78412B76889B76050B75562B71497B64259B60198B59469B53737B40952
1056B32801B31699B30324B21108B04401A94886A90514A79493A63743A55240A53103
1045A43281A26615A17387A15467A11815A03041I1586H5740H4839H1777G5313F7825
1033F3739F3133F2085E8838E4069E1396E0982E0425D9222D7789D6978D6859D7085
1020D7842D8456D8567D9893E2497E4069E5973E9649F1958F2900F5352F9073G1387
1007G3167G6291G9906H2555H5302H9081I2688I8808A03729A04978A07655A11479
995A13690A15614A19180A21305A22373A24203A25264A25464A25350A25051A24866
984A24805A23552A20711A18885A18599A17960A12765A07663A07000A05768A01748
973I5467I1701I0514H6330G8109G0903F5168E8859E4986E3750E2251D8505D2634
960C9011C8156C4987B9538B6578B5931B4109B0441A8128A7694A6994A4730A2887
947A2666A2163A1152A0419A0112I600I240H961H687H601H490H400H343H282H212
932H138H073H016G987G979G958G925G905G889G872G872G880G893G909G942G975
916H020H093H187H257H331H409H499H597H687H769H843H908H974I055I129I162
900I191I203I211I215I207I195I182I158I129I113I060H978H896H814H687H548
884H445H347H249H134H011G868G704G545G381G254G160G066F976F882F800F718
868F652F624F619F624F640F656F681F718F755F804F865F943F988G013G066G131
852G217G324G430G520G614G749G889H044H208H355H503H675H826I023I264I485
836I727I985A0206A0628A1061A1377A1819A2187A2552A3027A3444A3886A4472
823A4963A5471A6134A6674A7223A7968A8672A9409B0261B1194B2209B2750B2885
810B3393B4195B4731B5165B5788B6234B6660B7061B7155B7175B7212B7233B7036
797B6635B6361B6115B5620B4981B4543B4113B3172B2107B0785A9237A7620A6441
784A5831A4943A4267A3956A3522A2871A2429A2118A1688A1340A1147A0955A0697
771A0501A0382A0206A0030I948I878I801I747I731I719I710I719I768I846I923
756A0075A0247A0394A0607A0828A1074A1373A1622A1868A2150A2433A2715A2994
743A3268A3551A3849A4112A4337A4550A4681A4848A5012A5057A5082A5102A5090
730A5016A4914A4832A4672A4414A4169A3653A3162A2842A2400A1938A1373A0664
717I911I154H757H638H314G856G496G139F710F419F202E919E690E563E424E256
701E142E060D974D904D851D806D777D749D720D691D671D650D634D622D609D589
685D560D532D503D478D458D433D405D384D372D360D347D339D335D331D327D323
669D310D302D294D286D278D270D257D249D245D237D229D220D208D200D192D175
653D167D159D155D151D147D139D134D126D122D118D114D110D106D102D098D093
637D089D081D077D069D065D061D061D057D053D053D048D044D040D036D032D032
621D028D024D024D020D020D016D016D012D008D003C999C995C991C987C983C975
605C975C967C950C942C938C938C934C934C930C926C926C917C913C909C905C901
589C901C897C893C889C885C881C881C877C872C868C864C860C856C844C836C827
573C823C815C807C799C791C791C786C782C782C774C770C762C754C746C741C733
557C729C729C725C721C717C709C705C700C692C688C684C680C672C664C660C655
541C651C647C639C635C631C631C627C623C619C610C606C602C602C602C598C590
525C582C578C574C569C565C565C561C557C545C537C533C529C533C537C541C537
509C533C529C520C516C512C508C508C504C500C496C492C488C483C483C479C479
493C483C488C496C500C504C508C504C504C520C529C529C529C524C520C516C512
477C512C508C504C504C500C496C492C488C488C488C483C479C475C471C467C459
461C447C434C430C426C422C414C402C389C377C369C361C352C340C328C316C299
445C287C275C267C258C250C238C230C221C213C205C197C189C176C168C160C152
429C144C131C123C115C107C099C086C074C062C041C025C013C004B996B988B980
413B968B959B951B939B931B919B906B898B886B882B878B869B861B853B845B841
397B837B828B824B816B808B804B800B796B792B788B779B771B767B763B759B751
381B742B730B722B714B710B702B697B685B677B669B661B652B648B644B644B644
365B640B636B632B624B616B603B587B579B579B571B566B562B554B550B546B538
349B534B534B530B525B521B521B517B513B505B497B493B489B476B472B464B460
333B452B448B444B440B435B431B427B423B423B419B415B407B399B394B390B382
317B374B370B366B362B358B354B349B341B329B321B309B300B292B284B272B259
301B251B247B239B227B210B202B194B186B173B161B149B132B120B108B100B092
285B087B083B083B083B075B067B059B051B042B030B026B022B018B014B010B001
269A989A981A973A965A956A952A944A936A928A915A907A899A895A887A875A862
253A854A850A842A838A825A821A817A813A809A801A797A793A789A784A780A780
237A780A772A764A752A748A739A735A727A723A719A711A707A699A694A682A670
221A662A649A637A625A617A604A592A584A576A568A559A551A543A535A527A514
205A498A486A477A473A465A457A445A436A428A424A420A412A408A404A404A396
189A387A379A371A359A351A342A334A326A318A310A301A293A285A277A269A256
173A244A236A232A224A211A203A195A191A187A179A170A162A154A138A134A129
157A121A117A109A101A093A080A072A064A056A048A043A039A039A039A043A048
141A039A035A031A019A007I98I86I74I66I57I53I49I41I33I25I12I00H88H76H59
121H51H47H39H26H14H06G94G86G73G65G57G45G32G24G16G08G00F91F83F75F71
100F67F67F59F46F34F26F22F14F10F01E93E89E81E73E64E52E44E36E24E07D95
79D87D83D74D66D58D54D50D42D33D25D21D17D09D01C97C88C76C68C60C52C43
58C35C27C23C23C19C15C15C07C02B98B90B82B78B74B70B66B62B57B53B45B33
37B29B29B25B21B16B12B08B04B00A96A92A92A88A80A71A63A55A47A39A35A31
16A26A22A18A14D5@@@@@@@@@@@
$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##$OBSERVEDINTEGRALS= (X Y Z)
(4.059055939944362, 4.246935822409861, 1.0)
(4.426647081687358, 4.581851955020356, 1.959656251221741)
(5.1454921187973515, 5.357878387207351, 8.187385498143945)
(5.798987137642342, 5.962361150543841, 1.4178852922110234)
(7.29385705779782, 7.473568317075318, 0.472719123026026)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
$$ === CHEMSPECTRA SIMULATION ===
##$CSSIMULATIONPEAKS=
##END=
$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=ML-518_30min
##JCAMP-DX=5.00
##DATA TYPE=UVVISPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.05
##MAXX=10.000167
##MAXY=244.26
##MINX=0.0
##MINY=0.0
##$CSSOLVENTNAME=- - -
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=5
##PEAKTABLE= (XY..XY)
4.1593614955752205, 30.646
4.4922789810366615, 68.211
5.255039295828065, 244.26
5.882946958280657, 45.943
7.378968570164348, 13.998
##END=
$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=ML-518_30min
##JCAMP-DX=5.00
##DATA TYPE=UVVISPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.05
##MAXX=10.000167
##MAXY=244.26
##MINX=0.0
##MINY=0.0
##NPOINTS=5
##PEAKTABLE= (XY..XY)
5.255039295828065, 244.26
4.4922789810366615, 68.211
5.882946958280657, 45.943
4.1593614955752205, 30.646
7.378968570164348, 13.998
##END=
##END=
`;

export default uvVisJcamp;
